<template lang="pug">
.multiple
  Form(:model='question')
    .title
      Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
        @click='showAIDialog()',v-if='enableAI') AI生成
      Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
        Form(:model="aiForm" :label-width="80")
          FormItem(label="生成数量")
            InputNumber(v-model="aiForm.count" :min="1" :max="10" placeholder="请输入生成数量")
          FormItem(label='提示词',prop="stem")
            Input(v-model='aiForm.system' placeholder='请填写提示词'
              type="textarea" :rows="3")
      FormItem(prop='stem')
        Input(v-model='question.stem'  placeholder='题目内容')
      iDelModel(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
    FormItem(v-show='isEditTips' prop='tips')
      Input(v-model='question.tips' placeholder='编辑提示信息')
    .options
      FormItem(v-for='(item,index) in question.metas'
      label-position="right"
      :label='"#选项"+(index+1)'
      :label-width="80"
      :key='index')
        Input(v-model='question.metas[index]')
        Icon.cancelOption(type="ios-close-circle",
          v-if='index!==0',
          color='#E72020',
          @click='cancelOption(index)')
    FormItem(label-position='right' :label-width="80")
      Button(@click='addOption').btn + 添加
    FormItem(label='正确答案' prop='answer' label-position="right" :label-width="80")
      CheckboxGroup(v-model='question.answer')
        Checkbox(v-for='(item,index) in question.metas',:key='index',:label='"选项"+(index+1)')
    FormItem(label='答案解析' prop='analysis'  label-position="right" :label-width="80")
      Input(v-model='question.analysis' type="textarea" :rows="4")
    FormItem(label='分值'  label-position="right" :label-width="80")
      InputNumber(v-model='question.score',
        :max='100' :min='0',
        type="textarea",
        style='width:100px')
    FormItem
      isEditTips(:is-edit='isEditTips' :event='editTips')
</template>

<script>
import iDelModel from "@/components/common/iDelModel";
import isEditTips from "@/components/common/iEditTips";
import Bus from "../../utils/bus";

export default {
  components: {
    iDelModel,
    isEditTips
  },
  props: ["data", "haId", "taskId", "enableAI"],
  data() {
    return {
      question: {
        stem: "",
        tips: "",
        answer: [],
        metas: ["", ""],
        analysis: "", // 答案解析
        score: 0
      },
      options: [],
      optionsQuantity: 2, // 选项数量
      ruleValidate: {
        title: [
          {
            required: true,
            message: "标题不能为空",
            trigger: "blur"
          }
        ]
      },
      isEditTips: false,
      aiDialogVisible: false,
      aiForm: {}
    };
  },
  methods: {
    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { count: 1, system: "" };
    },
    generateCase() {
      if (this.taskId === "" || this.taskId === null || this.taskId === undefined) {
        this.$Message.error("无法生成！原因：需先保存当前场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "MULTIPLECHOICEA",
          count: this.aiForm.count,
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          haId: this.haId,
          score: 2,
          system: this.aiForm.system
        }
      };
      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
            Bus.$emit("refresh-task", this.taskId);
          } else {
            this.$emit("refresh-query");
          }
        }
      });
    },
    // 添加选项
    addOption() {
      console.log(this.question, "this.question.metas");
      if (!this.question.metas) this.question.metas = [];
      if (this.question.metas.length < 8) {
        // this.question.metas.length += 1;
        this.question.metas.push("");
      } else {
        this.$Message.error("最多只能存在8个选项");
      }
    },
    // 删除选项
    cancelOption(index) {
      if (this.question.metas.length > 2) {
        // this.this.question.metas -= 1;
        this.question.metas.splice(index, 1);
        this.question.answer = [];
      } else {
        this.$Message.error("最少必须保留2个选项");
      }
    },
    delModel() {
      this.$emit("delModel");
    },
    editTips() {
      // 编辑提示
      this.isEditTips = !this.isEditTips;
    }
  },
  watch: {
    optionsQuantity() {
      this.options = [];
      for (let i = 1, len = this.optionsQuantity; i <= len; i++) {
        this.options.push(`选项${i}`);
      }
    },
    // data(newval) {
    //   if (JSON.stringify(newval) !== "{}") {
    //     this.question = newval;
    //   }
    // },
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    for (let i = 1, len = this.optionsQuantity; i <= len; i++) {
      this.options.push(`选项${i}`);
    }
  },
  mounted() {
    this.$nextTick(async () => {
      if (Object.keys(this.data).length !== 0) {
        if (JSON.stringify(this.data) !== "{}") {
          this.question = await this.data;
        }
      }
      //   this.$emit("data1:data", this.question);
    });
  }
};
</script>

<style lang="stylus">
.multiple
  width 790px
  padding 24px 16px 24px 44px
  .title
    position relative
    .ivu-form-item-content
      width 75%
  .options
    .ivu-form-item-content
      margin-right 25px
      position relative
      .ivu-icon-ios-close-circle
        font-size 22px
        margin-left 10px
        position absolute
        top 6px
        color #E72020FF
        &:hover
          cursor pointer
.btn
  width 100px
  height 32px
</style>
